// assets
import { ChromeOutlined, QuestionOutlined } from '@ant-design/icons';

// icons
const icons = {
  ChromeOutlined,
  QuestionOutlined
};

// ==============================|| MENU ITEMS - SAMPLE PAGE & DOCUMENTATION ||============================== //

const support = {
  id: 'support',
  title: 'Reportes',
  type: 'group',
  children: [
    
     {
      id: 'sample-page',
      title: 'Reporte 5%',
      type: 'item',
      url: '/reporte5',
      icon: icons.ChromeOutlined
    },
     {
      id: 'sample-page',
      title: 'Reporte 2%',
      type: 'item',
      url: '/reporte2',
      icon: icons.ChromeOutlined
    },
     {
      id: 'finiquitos',
      title: 'Finiquitos',
      type: 'item',
      url: '/finiquitos',
      icon: icons.ChromeOutlined
    }
  ]
};

export default support;
